import { Volume1, Volume2, VolumeX } from 'lucide-react';

type VolumeSliderProps = {
  volume: number;
  muted: boolean;
  onChange(volume: number): void;
  onToggleMute(): void;
};

/**
 * Volume, on a **linear** gain law.
 *
 * The reference player's notes record that a logarithmic taper was tried and reverted
 * because it made the lower half of the travel nearly silent. Same conclusion applies
 * here, so the slider maps straight through to gain.
 */
export function VolumeSlider({ volume, muted, onChange, onToggleMute }: VolumeSliderProps) {
  const level = muted ? 0 : volume;
  const Icon = level === 0 ? VolumeX : level < 0.5 ? Volume1 : Volume2;

  return (
    <div className="volume">
      <button
        type="button"
        className="icon-button"
        onClick={onToggleMute}
        aria-label={muted ? 'Unmute' : 'Mute'}
        aria-pressed={muted}
      >
        <Icon size={17} />
      </button>
      <input
        type="range"
        min={0}
        max={1}
        step={0.01}
        value={level}
        onChange={(event) => onChange(Number(event.target.value))}
        aria-label="Volume"
        aria-valuetext={`${Math.round(level * 100)} percent`}
      />
    </div>
  );
}
